import { IManagedSiteCollection } from "../src/taskpane/interfaces/IManagedSite";
import { ISiteInfo, ISiteInfoLocation } from "../src/taskpane/interfaces/ISiteInfo";

export class SharePointSiteHelper {
    public static hubSites: ISiteInfo[] = [];
    public static managedSites: IManagedSiteCollection | undefined;
    public static provisionedSites: string[] | undefined;

    static reset(): void {
        this.hubSites = [];
        this.managedSites = undefined;
        this.provisionedSites = undefined;
    }

    static clearHubs(): void {
        this.hubSites = [];
    }

    static clearProvisionedSites(): void {
        this.provisionedSites = undefined;
    }

    static groupAndSortSites(sites: ISiteInfoLocation[]): ISiteInfoLocation[] {
        if (Array.isArray(sites)) {
            const hubSites = sites
                .filter(site => site.isHub)
                .sort(this.sortSites);

            return hubSites
                .concat(sites
                    .filter(site => !site.isHub)
                    .sort(this.sortSites));
        }
        return [];
    }

    static sortSites(siteA: ISiteInfo, siteB: ISiteInfo): number {
        return siteA.name?.toUpperCase() < siteB.name?.toUpperCase() ? -1 : 1;
    }

    static configureManagesSites(sites: ISiteInfo[]): void {
        if (Array.isArray(sites) && Array.isArray(this.managedSites?.sites) && this.managedSites.sites.length > 0) {
            for (const managedSite of this.managedSites.sites) {
                const site = sites.find(site => (
                    site?.webUrl && managedSite?.siteUrl && site.webUrl.toLowerCase().trim() === managedSite.siteUrl
                    || site?.id && managedSite?.siteId && site.id.toLowerCase().trim().indexOf(managedSite.siteId) !== -1));

                if (site) {
                    site.isManaged = true;
                    if (managedSite.siteGroup) {
                        site.managedGroup = managedSite.siteGroup;
                    }
                }
            }

            if (this.managedSites?.groups?.size > 0) {
                this.managedSites.groups.forEach(group => {
                    if (sites.some(site => site.managedGroup === group)) {
                        sites.push({
                            id: group,
                            name: group,
                            webUrl: undefined,
                            isSubsite: false,
                            isManagedGroup: true,
                            isManaged: true
                        });
                    }
                });
            }
        }
    }
}